<template>
  <main :class="'main image-bundles-page product-list-page page-inside product-list-page-' + activeType">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="wrapper">
          <div class="desc big">
            <b v-if="activeType == 'doc'">FIND PROMPTS</b>
            <b v-else>FIND BUNDLES</b>
          </div>
          <div class="input-container">
            <img src="./../assets/glass.svg" class="img"/>
            <input type="text" :placeholder="$t('Enter keywords')" @input="filterProducts" v-model="search"/>
            <button class="button" @click="filterProducts">
              {{$t('Search')}}
            </button>
          </div>
          <div class="select-container">
            <select v-model="sort" @change="filterProducts">
              <option selected hidden disabled value="">{{$t('Sort by price')}}</option>
              <option value="price~asc">{{$t('By price: Lowest to highest')}}</option>
              <option value="price~desc">{{$t('By price: From highest to lowest')}}</option>
            </select>
          </div>
        </div>
      </section>
      <section class="section hero-section product-list-section-active-categories" v-if="activeCategories.length || activeTag.length">
        <div class="wrapper">
          <div :class="{'no-tags': !activeCategories.length}" class="tags">
            <div v-for="category in activeCategories" class="button tags__item" :key="category.id">
              {{$t(category.title)}}
            </div>
          </div>
          <div :class="{'no-tags': !activeTag.length}" class="tags">
            <div v-for="category in activeTag" class="button tags__item" :key="category">
              {{$t(category)}}
            </div>
          </div>
        </div>
      </section>
      <section class="section product-list-section2">
        <div class="wrapper">
          <!-- <div class="top" v-if="productList && productList.length">
            <div class="left">
              <div class="title small">{{$t('Found')}} {{productList.length}} {{ $t('items by your request') }}</div>
            </div>
          </div> -->
          <!-- <div class="top" v-if="productList && !productList.length && (search || activeCategory)">
            <div class="left">
              <div class="title small">{{ $t('Found {amount} items by your request', {amount: productList.length}) }}</div>
            </div>
          </div> -->
          <div class="more-filters" @click="$parent.openFilterModal()">
            <img src="./../assets/filter.svg" class="img"/>
          </div>
          <!-- <transition name="fade">
            <div class="list categories" v-if="!productList.length && categoryOptions && categoryOptions.length && !search && !activeCategory">
              <div class="title">{{$t('Not sure what you are looking for? Search by categories!')}}</div>
              <div :class="['item-list', activeType]">
                <div class="item" v-for="(item, i) in filteredCategories" :key="i" @click="setCategory(item.id)">
                  <div class="img-container">
                    <img :src="$t(imgDomain + item.image_url)" class="img"/>
                  </div>
                  <div class="title small">{{$t(item.title)}}</div>
                </div>
              </div>
            </div>
          </transition> -->
          <div class="list products" v-if="productList && productList.length">
            <div class="item" v-for="(item, i) in productList" :key="i">
              <ImageBundle @openBuyModal="openBuyModal" :item="item" :sliderIsClickble="true" @goToProduct="goToProduct" :currency="currency" :categories="categoryOptions"/>
            </div>
            <div class="title no-products" v-if="!productList.length">
              {{$t('No products!')}}
            </div>
          </div>
        </div>

        <Pagination :per-page="perPage" :change-page="changePage" :current-page="activePage" :total-items="totalRecords"/>
      </section>
    </div>
  </main>
</template>

<script>
import ImageBundle from '../components/ImageBundle.vue';
import Pagination from "@/components/Pagination.vue";

export default {
  name: 'ProductList',
  props: ['currency', 'filter', 'appActiveType', 'isAuth'],
  components: {
    ImageBundle,
    Pagination
  },
  data: function() {
    return {
      imgDomain: '',
      sort: 'price~asc',
      category: [],
      model: [],
      productList: [],
      activeCategory: '',
      activeCategor: '',
      activeTag: '',
      activeType: '',
      categoryOptions: [],
      search: '',
      totalRecords: 0,
      activePage: 1,
      perPage: 5
    }
  },
  mounted() {
    const sort = localStorage.getItem("sort");
    if (sort) {
      this.sort = sort;
    }
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    let filterIsSet = false;

    if (this.$route.query['filter[category]']) {
      this.activeCategory = this.$route.query['filter[category]'];
      filterIsSet = true;
    } else {
      this.activeCategory = '';
    }

    if (this.$route.query['filter[tag]']) {
      this.activeTag = this.$route.query['filter[tag]'].split(",");
      filterIsSet = true;
    } else {
      this.activeTag = '';
    }

    this.checkType();

    if (filterIsSet) {
      this.filterProducts();
    }

    this.getCategories();
  },

	watch: {
    filter: function (newArr) {
      this.filterProducts(newArr);
    },
    currency: function() {
      // this.filterProducts();
    },
    $route() {
      this.productList = [];
      this.checkType();

      if (!this.$route.query['filter[category]']) {
        this.activeCategory = ''
      }

      if (!this.$route.query['filter[tag]']) {
        this.activeTag = ''
      }
    },
    appActiveType: function() {
      this.productList = [];
      this.activeCategory = '';
    },
    isAuth: function() {
      console.log('isAuth');
      this.filterProducts();
    },
    sort: function(newSort) {
      const sort = localStorage.getItem("sort");
      if (sort != newSort) {
        localStorage.setItem("sort", newSort);
      }
      
    },
	},
  computed: {
    filteredCategories() {
      return this.categoryOptions.filter(item => (item.url.includes(this.$route.params.type) && item.parent_id !== null));
    },
    activeCategories() {
      let categoryIds = this.activeCategory;

      if (categoryIds && this.categoryOptions) {
        if (typeof categoryIds === 'string' ) {
          categoryIds = categoryIds.split(',').map((id) => parseInt(id))
        } else if (Number.isInteger(categoryIds)) {
          categoryIds = [categoryIds];
        }

        return this.categoryOptions.filter(({id}) => categoryIds.includes(id));
      }

      return [];
    }
  },
  methods: {
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    checkType() {
      if (this.$route.params.type === 'images') {
        this.activeType = 'image';
      } else if (this.$route.params.type === 'texts') {
        this.activeType = 'doc';
      }
      this.filterProducts();
    },
    getCategories() {
      this.$http.get(process.env.VUE_APP_API + 'categories')
      .then((res) => {
        this.categoryOptions = res.data.payload;

        this.filterProducts();
      })
      .catch(() => {
         
      })
    },
    setCategory(id) {
        if (id == 'category') {
          this.activeCategory = this.activeCategor.id;
        } else {
          this.activeCategory = id;
        }
        const currentPath = this.$route.path;
        const currentQuery = this.$route.query;
        const newQuery = { ...currentQuery, 'filter[category]': this.activeCategory };
        this.$router.replace({ path: currentPath, query: newQuery });
        this.filterProducts();
    },
    goToProduct(item) {
      this.$emit('goToProduct', item)
    },
    openBuyModal(item, type) {
      this.$emit('openBuyModal', item, type)
    },
    filterProducts(params) {
      // Обработка категорий
      if (params?.activeCategories && Array.isArray(params.activeCategories)) {
        this.activeCategory = params.activeCategories.length
            ? params.activeCategories.map(obj => obj.id)
            : '';
      }

      // Обработка тегов
      if (params?.activeTags && Array.isArray(params.activeTags)) {
        this.activeTag = params.activeTags.length
            ? params.activeTags.map(obj => obj.name)
            : '';
      }

      // Собираем параметры запроса
      const queryParams = {
        type: this.activeType,
        ...(this.activeCategory && { categories_id: this.activeCategory }),
        ...(this.activeTag && { tags: this.activeTag }),
        ...(this.sort && { sort: this.sort }),
        ...(this.search && { search: this.search }),
        limit: this.perPage,
        page: this.activePage
      };

      // Делаем запрос с корректно переданными параметрами
      this.$http.get(process.env.VUE_APP_API + 'packs', {
        params: queryParams
      })
          .then((res) => {
            this.productList = res.data.payload;
            this.totalRecords = res.data.meta.total;
          })
          .catch((error) => {
            console.error('Error fetching products:', error);
            // Можно добавить обработку ошибок, например:
            // this.error = 'Не удалось загрузить продукты';
          });
    }
  }
}
</script>